import {
    Descriptions,
    message,
    Space,
    Spin,
    Checkbox,
    Card,
    Typography,
} from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import { AiOutlineCopy } from 'react-icons/ai';
import { IBusiness } from '../../../types/bussiness';
import ItemData from '../../../widgets/ItemData';

const { Text } = Typography;

interface DetailsHeadersProps {
    userBusiness: IBusiness;
    loadingAction: boolean;
    onChange: (e: CheckboxChangeEvent) => void;
}

const DetailsHeaders = ({
    userBusiness,
    loadingAction,
    onChange,
}: DetailsHeadersProps) => {
    const {
        userUniqueID,
        isDeleted,
        email,
        apiKey,
        businessID: {
            companyName,
            country,
            currency,
            fullAddress,
            addressNumber,
            building,
            internal,
            external,
            addressReference,
        },
    } = userBusiness;

    const items = [
        { label: 'Unique Id', value: userUniqueID },
        { label: 'Deleted', value: isDeleted ? 'Yes' : 'No' },
        { label: 'Email', value: email },
        { label: 'Country', value: country },
        { label: 'Currency', value: currency },
        {
            label: 'Api Key',
            value: (
                <Space size={8}>
                    {apiKey}
                    <AiOutlineCopy
                        style={{ marginLeft: 10 }}
                        color="#C9D6E8"
                        size={20}
                        onClick={() => {
                            navigator.clipboard.writeText(apiKey);
                            message.success('Api Key copied!');
                        }}
                        cursor="pointer"
                    />
                </Space>
            ),
        },
    ];

    const generateAddress = () => {
        const addressParts = [];

        // Información principal de dirección
        if (fullAddress) {
            addressParts.push(
                <Text key="fullAddress">
                    {fullAddress}
                </Text>,
            );
        }

        // Número y edificio
        const locationDetails = [];
        if (addressNumber) {
            locationDetails.push(
                <Space key="number" size={4}>
                    <Text strong>
                        Number:
                    </Text>
                    <Text>
                        {addressNumber}
                    </Text>
                </Space>,
            );
        }
        if (building) {
            locationDetails.push(
                <Space key="building" size={4}>
                    <Text strong>
                        Building:
                    </Text>
                    <Text>
                        {building}
                    </Text>
                </Space>,
            );
        }

        if (locationDetails.length > 0) {
            addressParts.push(
                <Text key="location">{locationDetails}</Text>,
            );
        }

        // Información interna/externa
        const accessInfo = [];
        if (internal) {
            accessInfo.push(`Internal: ${internal}`);
        }
        if (external) {
            accessInfo.push(`External: ${external}`);
        }

        if (accessInfo.length > 0) {
            addressParts.push(
                <Text key="access">{accessInfo.join(' ')}</Text>,
            );
        }

        // Referencia
        if (addressReference) {
            addressParts.push(
                <Space key="reference" size={4}>
                    <Text strong>
                        Reference:
                    </Text>
                    <Text>
                        {addressReference}
                    </Text>
                </Space>,
            );
        }

        return (
            <Text style={{
                display: 'block',
                textAlign: 'end',
                margin: '8px 0',
            }}
            >
                {addressParts}
            </Text>
        );
    };

    return (
        <Card title="Details">

            {
                items.map(({ label, value }) => (
                    <ItemData
                        key={label}
                        label={label}
                        value={value}
                    />
                ))
            }

            <ItemData
                label="Address"
                value={generateAddress()}
            />

            <ItemData
                label="API Address"
                value={(
                    <Checkbox
                        onChange={onChange}
                        defaultChecked={userBusiness?.externalAPIConfiguration?.ignoreAPIAddress}
                        disabled={loadingAction}
                    >
                        {loadingAction ? <Spin /> : 'Ignore'}
                    </Checkbox>
                )}
            />
        </Card>
    );
};

export default DetailsHeaders;
